import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Utility } from 'src/app/core/common';
import { LocationService } from 'src/app/services/location.service';
import { SharedService } from 'src/app/services/shared.service';
import { ValuesService } from 'src/app/services/values.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  websiteSchema: any;
  organizationSchema: any;

  constructor(public sharedService: SharedService, public locationService: LocationService, private valuesService: ValuesService) { }

  @Select(state => state.auth.user) user: Observable<any>;


  assetsUrl = environment.app.assetsUrl;
  data: any = {};

  params: any = {};

  async ngOnInit() {
    this.setSeo();
    this.data = await this.valuesService.homepage();
    if (this.locationService.lastLocations[0]) {
      this.params = { l: Utility.join('،', this.locationService.lastLocations[0].State, this.locationService.lastLocations[0].City) };
    }
  }

  private setSeo() {
    this.sharedService.setTitle('موتور جستجوی آگهی‌های استخدام سراسر کشور');
    this.sharedService.setKeywordsMeta('کاریابی', 'جستجوی نیروی کار', 'فرصت‌های شغلی', 'استخدام');
    this.sharedService.setDescriptionMeta('اینجا برای همه کار هست. موتور جستجوی آگهی‌های استخدام از وب‌سایت‌ها، اینستاگرام و کانال‌های شبکه ‌های اجتماعی. کامل‌ترین مرجع جستجوی فرصت‌های شغلی و آگهی‌های استخدام، کاریابی و جستجوی نیروی کار.');
    this.sharedService.resetNoIndex();
    this.sharedService.addLink({ rel: 'canonical', href: `${environment.app.url}/` });
    this.setStructuredData();
  }
  private setStructuredData() {
    this.websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": `${environment.app.url}/`,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${environment.app.url}/job;q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };
    this.organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "url": "https://karpishe.com",
      "logo": "https://karpishe.com/assets/images/logo/KarpisheLogo.png"
    };
  }


  companyLogo(logo: string) {
    if (!logo)
      return `/assets/images/clipart/avatar-company-1.svg`;
    return logo.startsWith('employer/') ? `${this.assetsUrl}${logo}` : `${this.assetsUrl}files/${logo}`;
  }
}
